module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sbox"
  }, [_c('h2', {
    staticClass: "subchapter",
    attrs: {
      "id": "s003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#s3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Make-Ahead Oatmeal Casserole")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Yield: Serves 6 | Prep Time: 15 minutes | Cook Time: 30 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "recipenote"
  }, [_vm._v("Before you crawl under the covers at night, assemble this oatmeal and set it in the fridge. When you wake up, all you have to do is brew a pot of coffee and pop the dish in the oven. The sweet blueberries folded throughout and the taste of buttery vanilla almonds make this a very special oatmeal. This casserole tastes like comfort and warmth on a cold winter weekend.")])]), _vm._v(" "), _c('p', {
    staticClass: "serves"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "indger1"
  }, [_vm._v("2 cups rolled oats")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("⅓ cup plus 2 tablespoons light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ cup dried cherries")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ cup blueberries, plus extra for serving")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("¼ cup toasted almonds")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup half-and-half")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 large egg")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 tablespoons unsalted butter, melted and cooled")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 teaspoon vanilla bean paste or vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("Honey and yogurt, for serving")]), _vm._v(" "), _c('h2', {
    staticClass: "Directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("1. Preheat the oven to 375°F and lightly coat an 8 × 8-inch baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("2. In a large bowl, combine the oats, ⅓ cup of the brown sugar, the baking powder, cinnamon, salt, dried cherries, half of the blueberries, and half of the almonds. Pour into the baking dish and top with the remaining blueberries and almonds. Whisk together the milk, half-and-half, egg, melted butter, and vanilla and pour on top of the oatmeal mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("3. At this point you can either sprinkle with the remaining 2 tablespoons brown sugar and bake for 30 minutes, or cover as is and place in the fridge overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("4. Once baked, remove from oven and scoop into individual serving bowls. Serve warm, topped with extra blueberries, yogurt, and honey if you wish.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c37c474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/s003.vue
// module id = 90
// module chunks = 0